/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { map } from 'rxjs/operators';
import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';

@Injectable()
export class FormsApi {
  private readonly apiController: string = 'forms';

  constructor(private api: HttpService) {}

  get formsDataSource(): DataSource {
    return this.api.getServerDataSource(`${this.api.apiUrl}/${this.apiController}`);
  }

  list(pageNumber: number = 1, pageSize: number = 10): Observable<any[]> {
    const params = new HttpParams()
      .set('pageNumber', `${pageNumber}`)
      .set('pageSize', `${pageSize}`);

    return this.api.get(this.apiController, { params })
      .pipe(map(data => data.map(item => {
        return { ...item };
      })));
  }

  getAll(): Observable<any> {
    return this.api.get(`${this.apiController}`)
    .pipe(map(data => data.map(item => {
      return { ...item };
    })));
  }

  
  getPublic(id: number): Observable<any> {
    return this.api.get(`public/${this.apiController}/${id}`)
      .pipe(map(data => {
        return { ...data , config: JSON.parse(data.config)};
      }));
  }

  get(id: number): Observable<any> {
    return this.api.get(`${this.apiController}/${id}`)
      .pipe(map(data => {
        return { ...data };
      }));
  }

  getAllResp(id: number): Observable<any> {
    return this.api.get(`${this.apiController}/resp/${id}`)
    .pipe(map(data => data.map(item => {
      return { ...item };
    })));
  }

  delete(id: number): Observable<boolean> {
    return this.api.delete(`${this.apiController}/${id}`);
  }

  add(item: any): Observable<any> {
    return this.api.post(this.apiController, item);
  }

  addResp(item: any): Observable<any> {
    return this.api.post(`public/${this.apiController}/resp`, item);
  }



  update(item: any): Observable<any> {
    return this.api.put(`${this.apiController}/${item.id}`, item);
  }
}
